import DodonesList from 'app/dodones/list/Index'
import HeaderContext from 'app/HeaderContext'
import useDodoneCollectionQuery from 'generated/api/dodones/useDodoneCollectionQuery'
import LoadingScreen from 'app/components/LoadingScreen'

export default () => {
  const { setText } = useContext(HeaderContext)
  const { isPending, data: { dodones, message } = {} } =
    useDodoneCollectionQuery({ query: { scheme: 'days' } })

  useEffect(() => {
    setText('Days')
  }, [])

  if (isPending) return <LoadingScreen />

  return (
    <div className="p-d flex-1 fcol">
      {message && (
        <div className="red-transparent-box p-2 rounded">
          
          Deu merda: {message}
        </div>
      )}
      {!message && <DodonesList dodones={dodones} />}
    </div>
  )
}
